import type { CanDeactivateFn } from '@angular/router';

/** A component that can report unsaved edits to the route-leave guard. */
export interface HasUnsavedChanges {
    hasUnsavedChanges(): boolean;
}

/**
 * Route-leave guard: if the component has unsaved edits, confirm before navigating away.
 * Cancel (Stay) aborts the navigation; OK (Discard) leaves and drops the edits. Inactive when clean.
 * Native confirm keeps this tiny — the app has no shared confirm-dialog service wired here yet.
 */
export const tpUnsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (component) => {
    if (!component?.hasUnsavedChanges?.()) return true;
    return window.confirm('You have unsaved section edits. Leave this page and discard them?');
};
